import { useBlockMoveGhostStore } from "../../stores/index.js";

/**
 * Floating chip that follows the finger while a calendar block is long-press-
 * moved WITH the inbox drawer open (mobile). Mounted once in the Shell, above
 * everything (incl. the z-40 inbox drawer) — the in-track ghost can't escape the
 * grid's nested stacking context, so it would otherwise drag behind the drawer.
 * When over the inbox it styles as "drop to un-schedule".
 */
export function BlockMoveGhost() {
  const { active, title, x, y, overInbox } = useBlockMoveGhostStore();
  if (!active) return null;
  return (
    <div
      className={`pointer-events-none fixed z-[71] max-w-[60vw] truncate rounded-md border-2 px-3 py-2 text-sm font-medium shadow-xl ${
        overInbox ? "border-destructive bg-destructive/10 ring-2 ring-destructive/40" : "border-primary bg-card ring-2 ring-primary/40"
      }`}
      style={{ left: x, top: y, transform: "translate(-50%, -130%)" }}
    >
      {overInbox ? "↩ Un-schedule" : title.trim() || "Task"}
    </div>
  );
}
